import { render } from "./BankDepositComponent.vue?vue&type=template&id=4cc87133&ts=true"
import script from "./BankDepositComponent.vue?vue&type=script&lang=ts"
export * from "./BankDepositComponent.vue?vue&type=script&lang=ts"

import "./BankDepositComponent.vue?vue&type=style&index=0&id=4cc87133&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/buyCrypto/BankDepositComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4cc87133"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4cc87133', __exports__)) {
    api.reload('4cc87133', __exports__)
  }
  
  module.hot.accept("./BankDepositComponent.vue?vue&type=template&id=4cc87133&ts=true", () => {
    api.rerender('4cc87133', render)
  })

}


export default __exports__